module.exports = __webpack_public_path__ + "media/images/locations/berlin-purple-7e11a07ebaca67602a0de3bf85f0ddc9.png";